var map = {
	"./altria-group-inc.png": 1760,
	"./archer-daniels-midland-co.png": 1761,
	"./british-american-tobacco-plc.png": 1762,
	"./chevron-corp.png": 1763,
	"./corecivic-inc.png": 1764,
	"./duke-energy-corp.png": 1765,
	"./exxon-mobil-corp.png": 1766,
	"./geogroup.png": 1767,
	"./jbs-sa.png": 1768,
	"./lockheed-martin-corp.png": 1769,
	"./northrop-grumman-corp.png": 1770,
	"./philip-morris-international-inc.png": 1771,
	"./raytheon-technologies-corp.png": 1772,
	"./smith--wesson-brands-inc.png": 1773,
	"./sturm-ruger--co-inc.png": 1774,
	"./tyson-foods-inc.png": 1775,
	"./vista-outdoor-inc.png": 1776
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2081;



//////////////////
// WEBPACK FOOTER
// ./static/images/cos ^\.\/.*\.png$
// module id = 2081
// module chunks = 0